import { SearchFormType } from '../../search-page/search-page-type.enum';
import { SeSideComponentType } from '../se-side-components/se-side-components-models';

// #region Interfaces

export interface ISeSideNavFeatureComponentState {
    title: string;
    description: string;
    icon: string | null;
    active: boolean;
    svgIcon?: string | null;
}

export interface ISeSideNavDetailsComponentState extends ISeSideNavFeatureComponentState {
    searchForm: SearchFormType | null;
    idColumnName: string;
}

// #endregion

// #region Types

export type SeSideNavComponentState = {
    [SeSideComponentType.reportHistory]: ISeSideNavFeatureComponentState;
    [SeSideComponentType.patientHistory]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.reportPreview]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.keyImagesPreview]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.reporting]: ISeSideNavFeatureComponentState,
    [SeSideComponentType.details]: ISeSideNavDetailsComponentState;
};

export interface SeSideNavState {
    components: SeSideNavComponentState;
    lastClickedTab?: SeSideComponentType | null;
}

// #endregion

// #region States
/**
 * Per le icone custom (svgIcon) è necessario prima trasformarle in font con l'app 'Icomoon' modificando tutto il file estensa-icons.ttf
 */
export const seSideNavComponentInitialState: SeSideNavState = {
    components: {
        [SeSideComponentType.reportHistory]: {
            title: 'ReportHistory',
            description: '',
            icon: 'assignment_add',
            svgIcon: 'icon_report_history', 
            active: false,
        },
        [SeSideComponentType.patientHistory]: {
            title: 'ClinicalHistory',
            description: '',
            icon: 'medical_information',
            active: false,
        },
        [SeSideComponentType.reportPreview]: {
            title: 'ReportPreview',
            description: '',
            icon: 'edit_note',
            active: false,
        },
        [SeSideComponentType.keyImagesPreview]: {
            title: 'KeyImages',
            description: '',
            icon: 'key',
            active: false,
        },
        [SeSideComponentType.reporting]: {
            title: 'Reporting',
            description: '',
            icon: 'description',
            svgIcon: 'icon_reporting',
            active: false,
        },
        [SeSideComponentType.details]: {
            title: 'Details',
            description: '',
            icon: 'list_alt',
            active: false,
            searchForm: null,
            idColumnName: ''
        },
    },
    lastClickedTab: null,
    /* ... Altri componenti esterni gestiti dall'ecg */
};

// #endregion
